import * as request from 'superagent';

// Should we false positive, or false negative if a technical
// issue disrupts a succesfull check?
// Mostly to avoid poor flashing, or unexpected
// user UX.  We should default to "hiding" it 
const FAILURE_RESPONSE = true;

// Send out a request to find out if this user has seen a given feature
export function retrieveIfUserHasSeenFeature(userID: string, tag: string, result: any) {
    const query = getQuery(userID, tag);

    request
        .get(query)
        .then((res) => {
            try {
                const response = JSON.parse(res.text);
                const asBool = response.result === 'true' || response.result === true || response.result === 'True';

                result(asBool);
            }
            catch (e) {
                result(FAILURE_RESPONSE);
            }
        });
}

export function launchUrl(url: string) {
    try {
        url = externalizeUrl(url);
        window.open(url, "_blank");
    }
    catch (e) {
        console.error(e);
    }
}

export function externalizeUrl(url: string) {
    try {
        url = url.replace("http://", "");
        url = url.replace("https://", "");
        url = `https://${url}`
    }
    catch (e) {
        console.error(e);
    }
    return url;
}

export function signalThatUserHasSeenFeature(userID: string, tag: string) {
    const query = getQuery(userID, tag, true);

    request
        .get(query)
        .end((err, res) => {
            // TODO: Check for issues here, and log them in a more detailed mannor
            // to track down potential issues
        });
}


function getQuery(userID: string, tag: string, value?: any) {
    const baseURL = process.env.NEXT_PUBLIC_FEATURE_URI + 'feature';
    let baseQuery = '?featureTag=' + tag + "&userID=" + userID;

    if (value !== undefined) {
        baseQuery += '&value=' + value.toString();
    }

    return baseURL + baseQuery;
}
